import React, { useEffect, useRef, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Loads an authenticated avatar image as a blob so the JWT can go through
 * an Authorization header (img src can't do that). Falls back to initials.
 */
export default function AuthedAvatar({ userId, name, size = 40, className = "" }) {
  const [blobUrl, setBlobUrl] = useState(null);
  const [failed, setFailed] = useState(false);
  const mounted = useRef(true);

  useEffect(() => {
    mounted.current = true;
    setBlobUrl(null); setFailed(false);
    if (!userId) return () => { mounted.current = false; };
    const token = localStorage.getItem("fb_token");
    if (!token) return () => { mounted.current = false; };
    let url;
    axios.get(`${API}/api/team/avatars/${userId}`, {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "blob",
    })
      .then((r) => {
        if (!mounted.current) return;
        url = URL.createObjectURL(r.data);
        setBlobUrl(url);
      })
      .catch(() => { if (mounted.current) setFailed(true); });
    return () => {
      mounted.current = false;
      if (url) URL.revokeObjectURL(url);
    };
  }, [userId]);

  const initials = (name || "?")
    .split(/\s+/).filter(Boolean).slice(0, 2)
    .map((s) => s[0]?.toUpperCase()).join("") || "?";

  const dim = { width: size, height: size };
  if (blobUrl && !failed) {
    return (
      <img
        src={blobUrl} alt={name || "avatar"}
        className={`rounded-full object-cover border border-cream ${className}`}
        style={dim}
      />
    );
  }
  return (
    <div
      className={`rounded-full bg-forest text-white flex items-center justify-center font-semibold border border-cream ${className}`}
      style={{ ...dim, fontSize: Math.round(size * 0.4) }}
    >
      {initials}
    </div>
  );
}
